import { Container, Row, Col } from "react-bootstrap/";
import { Typewriter } from "react-simple-typewriter";
import "./LandingPage.css";
import Atropos from "atropos/react";
import "atropos/atropos.css";
import Resume from "../Assets/Divyansh Goyal's Resume.pdf";

function LandingPage() {
  const stats = [
    { label: "Degrees", value: "2", sub: "Software Engineering & Business" },
    { label: "Experience", value: "2+", sub: "Years in Industry" },
    { label: "Certifications", value: "3+", sub: "AWS, Azure, & IBM" },
    { label: "Publication", value: "1", sub: "First Author • IEEE SSCI" },
  ];

  return (
    <Container className="landingPageContainer">
      <Row className="align-items-center g-4">
        <Col xs={12} lg={6} className="order-2 order-lg-1">
          <div className="introText text-start">
            {/* Recruiter Highlight Pill */}
            <div className="recruiterPill mb-3">
              <span className="pillDot"></span>
              <span>Application Developer @ IBM &bull; Cloud &amp; Agentic AI</span>
            </div>

            <h1 className="heroTitle">
              <Typewriter
                words={["", "Hey, I'm Divyansh Goyal!"]}
                loop={1}
                cursor={false}
                cursorStyle="|"
                typeSpeed={70}
              />
            </h1>

            <div className="roleCaption">
              Software Engineer <span>•</span> Cloud <span>•</span> AI
            </div>

            <p className="heroDescription">
              Creating reliable, high-quality software with real-world value.
            </p>

            <div className="CTAButtons">
              <a href="/projects" className="btn-primary-custom">
                View Projects &rarr;
              </a>
              <a href="/technicalExperience" className="btn-primary-custom">
                Work Experience &rarr;
              </a>
              <a
                href={Resume}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary-custom"
              >
                📄 Resume
              </a>
            </div>

            {/* Quick Metrics Bar */}
            <div className="heroStatsGrid mt-4">
              {stats.map((item, idx) => (
                <div key={idx} className="heroStatCard">
                  <div className="statValue">{item.value}</div>
                  <div className="statLabel">{item.label}</div>
                  <div className="statSub">{item.sub}</div>
                </div>
              ))}
            </div>
          </div>
        </Col>

        <Col xs={12} lg={6} className="order-1 order-lg-2 text-center">
          <div className="landingImgWrapper">
            <Atropos
              component="div"
              activeOffset={10}
              shadow={false}
              highlight={false}
              className="atroposContainer"
            >
              <img
                loading="eager"
                className="landingImg img-fluid"
                src={require("../images/formal.jpeg")}
                alt="Divyansh Goyal"
              />
            </Atropos>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default LandingPage;
